import React, { createContext, useContext, useState } from 'react';

import {
  ListingFilterContextProviderProps,
  ListingFilterContextReturn
} from './types/listing-filter';
import { STATUS } from '../../enum/listing-status';

export const ListingFilterContext = createContext<ListingFilterContextReturn | undefined>(
  undefined
);

export function ListingFilterContextProvider({
  children
}: Readonly<ListingFilterContextProviderProps>): JSX.Element {
  const [selectedOption, setSelectedOption] = useState<keyof typeof STATUS>('all');

  return (
    <ListingFilterContext.Provider
      value={{
        selectedOption,
        setSelectedOption
      }}
    >
      {children}
    </ListingFilterContext.Provider>
  );
}

export function useListingFilterContext(): ListingFilterContextReturn {
  const context = useContext(ListingFilterContext);

  if (!context) {
    throw new Error('Listing filter is not available');
  }

  return context;
}
